var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"checkbox\" ng-if=\"$ctrl.action === 'move'\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.emailConfirmation\" name=\"emailConfirmation\" ng-click=\"$ctrl.click()\"/>\n<span translate=\"ADMIN_BOOKING.CALENDAR.MOVE_BOOKING_CHECKBOX\" translate-values=\"{ email: $ctrl.email }\"></span>\n</label>\n</div>";
var id1="public-booking/email-confirmation-checkbox/bb_email_confirmation_checkbox.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/email-confirmation-checkbox/bb_email_confirmation_checkbox.html
// module id = 1221
// module chunks = 0